// extracted by mini-css-extract-plugin
export default {"container":"_7m2jR","mobileContainer":"azDtG","overlay":"y7apU","svgContainer":"zToWu"};